import { path } from "ramda";

export const selector = path(["watchListUpdateLogs", "data"]);
export const pageInfoSelector = path(["watchListUpdateLogs", "pageInfo"]);
export const watchListUpdateLogsFiltersSelector = path([
  "watchListUpdateLogs",
  "filters",
]);
export const watchListUpdateLogsLoadingSelector = path([
  "watchListUpdateLogs",
  "isLoading",
]);

// Single Client
export const singleClientReportEntriesSelector = path([
  "singleClientReportEntries",
  "data",
]);
export const singleClientReportPageInfoSelector = path([
  "singleClientReportEntries",
  "pageInfo",
]);

export const singleClientReportFiltersSelector = path([
  "singleClientReportEntries",
  "filters",
]);

export const singleClientReportIsLoadingSelector = path([
  "singleClientReportEntries",
  "isLoading",
]);

export const singleClientReportNoEntriesMessageSelector = path([
  "singleClientReportEntries",
  "noEntriesMessage",
]);

export const singleClientReportDetailsSelector = path([
  "singleClientReportDetails",
  "data",
]);

export const singleClientReportDetailsLoadingSelector = path([
  "singleClientReportDetails",
  "isLoading",
]);

export const singleClientReportLinkedClientsExpandedRowsSelector = path([
  "singleClientReportDetails",
  "expandedRowsLinkedClients",
]);

export const singleClientReportPdfSelector = path([
  "exportSingleClientReportPdf",
  "data",
]);

export const singleClientReportPdfIsLoadingSelector = path([
  "exportSingleClientReportPdf",
  "isLoading",
]);

export const singleClientReportCollapsesClosed = path([
  "singleClientReportDetails",
  "collapsesClosed",
]);

// Multiple CLient
export const multipleClientReportPdfSelector = path([
  "exportMultipleClientReportPdf",
  "data",
]);
export const multipleClientReportHtmlSelector = path([
  "exportMultipleClientReportHtml",
  "data",
]);

export const multipleClientReportPdfFiltersSelector = path([
  "exportMultipleClientReportPdf",
  "filters",
]);
export const multipleClientReportHtmlFiltersSelector = path([
  "exportMultipleClientReportHtml",
  "filters",
]);

export const multipleClientReportPdfIsLoadingSelector = path([
  "exportMultipleClientReportPdf",
  "isLoading",
]);
export const multipleClientReportHtmlIsLoadingSelector = path([
  "exportMultipleClientReportHtml",
  "isLoadingHtml",
]);

export const multipleClientsReportSelector = path([
  "multipleClientsReport",
  "data",
]);
export const multipleClientsReportFiltersSelector = path([
  "multipleClientsReport",
  "filters",
]);

export const isLoadingSelector = path(["multipleClientsReport", "isLoading"]);

// Scoring Results
export const scoringResultsReportEntriesSelector = path([
  "scoringResultsReportEntries",
  "data",
]);
export const scoringResultsIsLoadingSelector = path([
  "scoringResultsReportEntries",
  "isLoading",
]);
export const scoringResultsReportFiltersSelector = path([
  "scoringResultsReportEntries",
  "filters",
]);
export const scoringResultsReportPageInfoSelector = path([
  "scoringResultsReportEntries",
  "pageInfo",
]);
export const scoringResultsReportNoEntriesMessageSelector = path([
  "scoringResultsReportEntries",
  "noEntriesMessage",
]);
export const scoringResultsReportScoringTypesSelector = path([
  "scoringResultsScoringTypes",
  "data",
]);
export const scoringResultsReportExportIsLoading = path([
  "exportScoringResultsReportCsv",
  "isLoading",
]);
export const scoringResultsReportExportCsv = path([
  "exportScoringResultsReportCsv",
  "data",
]);
export const scoringResultsReportCsvSelector = path([
  "exportScoringResultsReportCsv",
  "data",
]);



// WEBPACK FOOTER //
// ./src/features/reports/selectors/index.js